module.exports = __webpack_public_path__ + "static/media/secondFloorFront.828ba402.png";